import * as React from 'react';
import ResetSendMessage from './../containers/ResetSendMessage';

export default (props) => (<ResetSendMessage {...props} />);
